<template>
    <div>
        <div>
            <div>
                <div>
                    <h2 class="mb-0">Fees</h2>
                    <h4 class="mb-4">The default fees for calculating the landed price.</h4>
                    <Fees v-if="form_data" v-model="form_data"></Fees>
                    <b-button @click="onSubmit">Submit</b-button>
                </div>

            </div>
        </div>
    </div>
</template>
<script>
    import api from '../../api/api_resource';
    import Fees from '../User/Fees'

    export default {
        components: {
            Fees
        },
        created() {
            this.getData()
        },
        data() {
            return {
                form_data: null,
            }
        },
        methods: {
            async onSubmit() {
                try {
                    let result = await api.post('settings.update-fees', [], this.form_data)
                    this.$message.success(result.message);

                } catch (error) {
                    this.$message.error(error.message);
                }
            },
            async getData(){
                try {
                    let res = await this.axios.get(this.$laravelRoute('settings.get-fees'))
                    if (res.data && res.data.default) {
                        this.form_data = res.data.default
                    }
                } catch (e) {
                    console.warn('error getting fees', e)
                }
            },
        },
    }
</script>



// WEBPACK FOOTER //
// resources/js/components/Forms/FeesPage.vue